<template>
  <div>
    <h2>Editar Genética</h2>
    <form @submit.prevent="actualizarGenetica">
      <div class="mb-3">
        <label for="nombre" class="form-label">Nombre:</label>
        <input v-model="geneticaLocal.nombre" type="text" class="form-control" id="nombre" required />
      </div>

      <div class="mb-3">
        <label for="descripcion" class="form-label">Descripción:</label>
        <textarea v-model="geneticaLocal.descripcion" class="form-control" id="descripcion" rows="3"></textarea>
      </div>

      <div class="mb-3">
        <label for="thc" class="form-label">THC (%):</label>
        <input v-model="geneticaLocal.thc" type="number" class="form-control" id="thc" required />
      </div>

      <div class="mb-3">
        <label for="cbd" class="form-label">CBD (%):</label>
        <input v-model="geneticaLocal.cbd" type="number" class="form-control" id="cbd" required />
      </div>

      <!-- Campo: Tipo Origen -->
      <div class="mb-3">
        <label for="tipo_origen" class="form-label">Tipo Origen:</label>
        <select v-model="geneticaLocal.tipo_origen" class="form-select" id="tipo_origen" required>
          <option disabled value="">Seleccione un tipo de origen</option>
          <option v-for="origen in origenes" :key="origen" :value="origen">
            {{ origen }}
          </option>
        </select>
      </div>

      <!-- Campo: Tipo Cannabis -->
      <div class="mb-3">
        <label for="tipo_cannabis" class="form-label">Tipo Cannabis:</label>
        <select v-model="geneticaLocal.tipo_cannabis" class="form-select" id="tipo_cannabis" required>
          <option disabled value="">Seleccione un tipo de cannabis</option>
          <option v-for="tipo in tiposCannabis" :key="tipo" :value="tipo">
            {{ tipo }}
          </option>
        </select>
      </div>

      <!-- Campo: Tiempo de Floración -->
      <div class="mb-3">
        <label for="tiempo_floracion" class="form-label">Tiempo de Floración (días):</label>
        <input v-model="geneticaLocal.tiempo_floracion" type="number" class="form-control" id="tiempo_floracion" />
      </div>

      <!-- Campo: Rendimiento -->
      <div class="mb-3">
        <label for="rendimiento" class="form-label">Rendimiento (kg o unidad):</label>
        <input v-model="geneticaLocal.rendimiento" type="number" class="form-control" id="rendimiento" />
      </div>

      <!-- Campo: Observaciones -->
      <div class="mb-3">
        <label for="observaciones" class="form-label">Observaciones:</label>
        <textarea v-model="geneticaLocal.observaciones" class="form-control" id="observaciones" rows="3"></textarea>
      </div>

      <!-- Campo: Tipo de Resina -->
      <div class="mb-3">
        <label for="tipo_resina" class="form-label">Tipo de Resina:</label>
        <select v-model="geneticaLocal.tipo_resina" class="form-select" id="tipo_resina">
          <option disabled value="">Seleccione un tipo de resina</option>
          <option v-for="resina in tiposResina" :key="resina" :value="resina">
            {{ resina }}
          </option>
        </select>
      </div>

      <!-- Campo: Perfil Aromático -->
      <div class="mb-3">
        <label for="perfil_aromatico" class="form-label">Perfil Aromático:</label>
        <select v-model="geneticaLocal.perfil_aromatico" class="form-select" id="perfil_aromatico">
          <option disabled value="">Seleccione un perfil aromático</option>
          <option v-for="perfil in perfilesAromaticos" :key="perfil" :value="perfil">
            {{ perfil }}
          </option>
        </select>
      </div>

      <!-- Campo: Perfil de Terpenos -->
      <div class="mb-3">
        <label for="perfil_terpenos" class="form-label">Perfil de Terpenos:</label>
        <select v-model="geneticaLocal.perfil_terpenos" class="form-select" id="perfil_terpenos">
          <option disabled value="">Seleccione un perfil de terpenos</option>
          <option v-for="perfil in perfilesTerpenos" :key="perfil" :value="perfil">
            {{ perfil }}
          </option>
        </select>
      </div>

      <!-- Campo: Fecha de Registro (solo lectura) -->
      <div class="mb-3">
        <label for="fecha_registro" class="form-label">Fecha de Registro:</label>
        <input v-model="geneticaLocal.fecha_registro" type="date" class="form-control" id="fecha_registro" disabled />
      </div>

      <button type="submit" class="btn btn-primary">Guardar Cambios</button>
    </form>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  props: {
    genetica: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // Copia local de la genética para editar
      geneticaLocal: {
        nombre: "",
        descripcion: "",
        thc: null,
        cbd: null,
        tipo_origen: "",
        tipo_cannabis: "",
        tiempo_floracion: null,
        rendimiento: null,
        observaciones: "",
        fecha_registro: "",
        tipo_resina: "",
        perfil_aromatico: "",
        perfil_terpenos: "",
      },
      origenes: [],          // Opciones para tipo_origen
      tiposCannabis: [],     // Opciones para tipo_cannabis
      tiposResina: [],       // Opciones para tipo_resina
      perfilesAromaticos: [],// Opciones para perfil_aromatico
      perfilesTerpenos: [],  // Opciones para perfil_terpenos
    };
  },
  created() {
    // Inicializa la copia local con los valores de la prop
    this.geneticaLocal = { ...this.genetica };
  },
  methods: {
    async actualizarGenetica() {
      try {
        await axios.put(`/api/actualizarGenetica/${this.geneticaLocal.id}`, this.geneticaLocal);
        alert("Genética actualizada con éxito");
        this.$emit("accionTerminada");
      } catch (error) {
        console.error("Error al actualizar la genética:", error);
      }
    },
    async cargarOrigenes() {
      try {
        const response = await axios.get('/api/constantes/origen_genetica_cannabis');
        this.origenes = response.data;
      } catch (error) {
        console.error("Error al cargar los orígenes:", error);
      }
    },
    async cargarTiposCannabis() {
      try {
        const response = await axios.get('/api/constantes/tipos_cannabis');
        this.tiposCannabis = response.data;
      } catch (error) {
        console.error("Error al cargar los tipos de cannabis:", error);
      }
    },
    async cargarTiposResina() {
      try {
        const response = await axios.get('/api/constantes/tipos_resina');
        this.tiposResina = response.data;
      } catch (error) {
        console.error("Error al cargar los tipos de resina:", error);
      }
    },
    async cargarPerfilesAromaticos() {
      try {
        const response = await axios.get('/api/constantes/perfiles_aromaticos');
        this.perfilesAromaticos = response.data;
      } catch (error) {
        console.error("Error al cargar los perfiles aromáticos:", error);
      }
    },
    async cargarPerfilesTerpenos() {
      try {
        const response = await axios.get('/api/constantes/perfiles_terpenos');
        this.perfilesTerpenos = response.data;
      } catch (error) {
        console.error("Error al cargar los perfiles de terpenos:", error);
      }
    },
  },
  mounted() {
    this.cargarOrigenes();
    this.cargarTiposCannabis();
    this.cargarTiposResina();
    this.cargarPerfilesAromaticos();
    this.cargarPerfilesTerpenos();
  },
};
</script>

<style scoped>
/* Estilos específicos para el componente */
</style>
